import { Box, Button, Container, Typography } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import useList from "./useList";
import Subscription from "@/templates/Subscription";

export const List = () => {
  const { list, handleGoToCreate, isLoading } = useList();

  return (
    <Container maxWidth={"xl"}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        gap={2}
        alignItems={"end"}
        mb={2}
      >
        <Typography
          component={"h1"}
          variant="h5"
          fontWeight={"bold"}
          gutterBottom
        >
          구독 상품 목록
        </Typography>
        <Button
          variant={"contained"}
          disableElevation
          startIcon={<AddIcon />}
          onClick={handleGoToCreate}
        >
          구독 상품 등록
        </Button>
      </Box>
      <Subscription.List list={list} isLoading={isLoading} />
    </Container>
  );
};
